import { z } from 'zod';
import { c } from '../../contract';
import { ListeningProgressList, ReadingProgressList } from '../../types';

export const progressResetRouter = c.router(
  {
    getUnlimitedProgress: {
      path: '/progress/unlimited',
      method: 'GET',
      responses: {
        200: z.object({
          readingProgress: ReadingProgressList,
          listeningProgress: ListeningProgressList,
        }),
      },
    },
    getUnsubscribedProgress: {
      path: '/progress/unsubscribed',
      method: 'GET',
      responses: {
        200: z.object({
          readingProgress: ReadingProgressList,
          listeningProgress: ListeningProgressList,
        }),
      },
    },
    subscriptionExpired: {
      path: '/subscription-expired',
      method: 'POST',
      body: z.object({
        testResettingProgressVariant: z.string(),
      }),
      responses: {
        200: z.object({
          progressWasSwapped: z.boolean(),
          unlimitedProgress: z.object({
            readingProgress: ReadingProgressList,
            listeningProgress: ListeningProgressList,
          }),
        }),
      },
    },
  },
  { pathPrefix: '/progress-reset' },
);
